import ReactTooltip from "react-tooltip";
import { ChipDropdownProps } from "../../types";
import HelpIcon from "../../assets/icons/help-circle.svg";
import DownIcon from "../../assets/icons/down.svg";
import {
  ChipInputRoot,
  ErrorInputText,
  Label,
  InputBoxDropdown,
  InputBoxDropdownSectionOne,
  PlaceholderText,
  CheckboxLabel,
  ChipGrid,
  InputBoxDropdownSectionTwo,
  DropdownList,
  MyCheckbox,
} from "./InputBox.styles";
import Chip from "../chip/Chip";
import React, { useEffect, useRef, useState } from "react";
import ChipImage from "./ChipImage";

function ChipDropdown(props: ChipDropdownProps) {
  const {
    id,
    labelName,
    placeHolderName,
    chips,
    error,
    style,
    showTooltip = false,
    onCloseChip,
    setGradeList,
    toolTipMessage,
    resetFormDataError,
  } = props;

  const [open, setOpen] = useState(false);
  const [dropdownItems, setDropdownItems] = useState(
    [
      {
        id: 1,
        value: "GV",
      },
      {
        id: 2,
        value: "MI",
      },
      {
        id: 3,
        value: "MII",
      },
    ].map((dropdownItem) => ({
      ...dropdownItem,
      checked: chips.includes(dropdownItem.value),
    }))
  );
  const ref = useRef<HTMLDivElement>(null);

  const handleClick = () => {
    setOpen((prev) => !prev);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    if (checked) setGradeList((prev) => [...prev, name]);
    else setGradeList((prev) => prev.filter((item) => item !== name));

    setDropdownItems((prev) => {
      return prev.map((item) => {
        if (item["value"] === name) return { ...item, checked };
        else return item;
      });
    });
    if (checked && chips.length === 0) resetFormDataError("Grade");
  };

  const renderPlaceholder = () => (
    <PlaceholderText>{placeHolderName}</PlaceholderText>
  );

  const renderChips = () => {
    return (
      <ChipGrid>
        {chips?.map((chip, idx) => (
          <Chip
            chip={chip}
            key={idx}
            onCloseChip={(e: React.SyntheticEvent) => {
              e.stopPropagation();
              onCloseChip(chip);
              setDropdownItems((prev) => {
                return prev.map((item) => {
                  if (item["value"] === chip)
                    return { ...item, checked: false };
                  else return item;
                });
              });
              setGradeList((prev) => prev.filter((item) => item !== chip));
            }}
          />
        ))}
      </ChipGrid>
    );
  };

  useEffect(() => {
    const handleOutsideClick = (e: MouseEvent) => {
      if (ref.current && e.target) {
        if (!ref.current.contains(e.target as Node)) setOpen(false);
      }
    };

    window.addEventListener("click", handleOutsideClick);
    return () => {
      window.removeEventListener("click", handleOutsideClick);
    };
  });

  return (
    <ChipInputRoot style={{ ...style }}>
      <Label error={Boolean(error)} htmlFor={id}>
        {labelName}
        {showTooltip && (
          <ChipImage
            styles={{ verticalAlign: "middle", paddingLeft: "8px" }}
            icon={HelpIcon}
            alt="help-icon"
            id={id}
          />
        )}
        {showTooltip && (
          <ReactTooltip
            id={id}
            place="bottom"
            effect="solid"
            className="tooltip-custom"
            backgroundColor={"#636C79"}
            offset={{ left: -5 }}
          >
            {toolTipMessage}
          </ReactTooltip>
        )}
      </Label>
      <InputBoxDropdown ref={ref} onClick={handleClick}>
        <InputBoxDropdownSectionOne>
          {chips.length == 0 ? renderPlaceholder() : renderChips()}
        </InputBoxDropdownSectionOne>
        <InputBoxDropdownSectionTwo>
          <img src={DownIcon} alt="down" />
        </InputBoxDropdownSectionTwo>
        {open && (
          <DropdownList
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            {dropdownItems.map((item, idx) => (
              <div key={idx} style={{ padding: "4px" }}>
                <MyCheckbox
                  type="checkbox"
                  name={item["value"]}
                  id={item["value"]}
                  checked={item["checked"]}
                  onChange={handleChange}
                />
                <CheckboxLabel htmlFor={item["value"]}>
                  {item["value"]}
                </CheckboxLabel>
              </div>
            ))}
          </DropdownList>
        )}
      </InputBoxDropdown>
    </ChipInputRoot>
  );
}

export default ChipDropdown;
